export default __webpack_public_path__ + "img/4db51100c6eefab5a582f94dbf06c571.svg";